import React from "react";
import "./personality-one.scss";
import {Link} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AppFooter from "../../../../components/appFooter";


export default function PersonalityOne(props) {
    return (
        <div className={"mainDiv"}>
            <div className="brand-bg-inverse-color mb-3 fancyFont">
                <div className="container">
                    <nav className="navbar navbar-expand-sm navbar-dark brand-bg-inverse-color">
                        <Link to={"/"} className="navbar-brand">
                            <img src={require("../../../../assets/logo.png")} alt="" width={"140px"}/>
                        </Link>
                    </nav>
                </div>
            </div>

            <div className="container fancyFont">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className="h3 brand-text-color inner-header">M. Suhail Khandwani</h3>
                    </div>

                    <div className="col-lg-12">
                        <p>Mr. Suhail Khandwani is a name to reckon within the Indian social circuit. He belongs to the
                            illustrious family of Khandwani’s where mutual trust and faith runs in the blood. Theirs is
                            the
                            saga of an Indian family that introduced Hajj voyages by sea for all, between Mumbai and
                            Jeddah (Khandwani Steam Navigation Company) and took the first car to the desert
                            kingdom.</p>
                        <p>Mr. Suhail Khandwani wears many faceted hats. A member of the Maharashtra Chambers of
                            Housing Industry (MCHI) and Practicing Engineers Architects &amp; Town Planners
                            Associates (PEATA), he is also part of Bombay Management Association (BMA), Property
                            Owners Association (POA), The Federation of Accommodation Industry of India (FOAII)
                            as well as National Real Estate Development Council (NAREDCO) he is the Patron of World
                            Memon Organisation (a worldwide central organisation representing the entire Memon
                            Community), Vice President of All India Memon Jamat Federation, President of Khandwani
                            Jamat, Vice President of Memon Chamber of Commerce, Managing Trustee of Mahim Dargah,
                            Haji Ali Dargah and Managing Trustee of Al Barkaat Malik Muhammad Islam English
                            School which has over 3,000 students and General Council Member of many social and
                            academic institutions one of which is the illustrious Anjuman-I-Islam a group with more than
                            95
                            institutions catering to various faculties, Patron of Association of Muslim Professionals
                            (AMP), which works among students and youngsters of our community in guiding them towards
                            better careers and helps them find a respectable living, he has been awarded an Honorary
                            Doctorate for Social Service by the, Regional Research Centre, University of Asia. He holds
                            eminent positions in various known Educational, Social and Community.</p>
                        <p>An astute businessman with a discerning understanding of technology, he is at the helm of a
                            real estate company that has constructed prime real estate landmarks around the country.
                            Enriching a legacy of 50 years through constant innovation, a discerning taste in design and
                            a
                            keen eye for bringing dreams to life, he has taken the iconic Khandwani Group to incredible
                            new heights and avenues. He pilots a strong core team with multifaceted professionals across
                            functions that form the foundation for a company with a leading edge.</p>
                        <p>A philanthropist, and a social businessman, he has been instrumental in uplifting not just
                            the
                            Group but entire ecosystems that associate with him making homogenous growth a mission,
                            that is brought to life through the Vision of the Khandwani Group. With several projects
                            already standing tall, he is backed by years of experience and holds the trust of loyal
                            clients.</p>
                        <p>He has actively participated in relief work and various activities promoting inter-religious
                            dialogue to strengthen inter-religious bonds thereby instilling peace and harmony in the
                            society.</p>
                        <p>His objective is to create a model community which is socially proactive and contributes
                            wholeheartedly to the progress of the society and growth of the Country.</p>
                    </div>
                </div>
            </div>
            <AppFooter/>
        </div>);
}
